import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as actions from '../../../../_redux/reconcile/reconcileAction';
import { useDispatch } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import { toastOption } from '../../../../../../../_metronic/_helpers';
export const ReconcileDeleteDialog = ({ openDeleteDialog, handleCloseDeleteDialog, selectedRow, params }) => {

  const dispatch = useDispatch();

  const deleteReconcile = (uuid) => {
    dispatch(actions.deleteReconcile(uuid)).then(async response => {
      dispatch(actions.fetchReconciles(params))
      toast.success(response, toastOption);
      handleCloseDeleteDialog()
    })
  }


  return (
    <div>
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-danger">Hapus Settlement</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Apakah anda yakin akan menghapus rekonsiliasi ?
            <br />
            Donasi yang terkait dengan data yang dihapus akan otomatis terlepas kaitannya.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="secondary">
            Batal
          </Button>
          <Button onClick={() => deleteReconcile(selectedRow)} color="primary" autoFocus>
            Oke
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
